module.exports = __webpack_public_path__ + "media/audio3.cf33270b.mp3";